/* ========================================
   Noble Aroma - Cart Drawer Interactive JS
   ======================================== */

(function() {
  'use strict';

  /* -------------------------------------------
     1. LIGHTBOX SYSTEM (inside drawer)
     ------------------------------------------- */

  function openLightbox(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.style.display = 'flex';
  }

  function closeLightbox(el) {
    if (!el) return;
    var overlay = el.closest('.noble-lightbox-overlay');
    if (overlay) overlay.style.display = 'none';
  }

  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('noble-lightbox-overlay')) {
      e.target.style.display = 'none';
    }
    var closeBtn = e.target.closest('[data-close-lightbox]');
    if (closeBtn) {
      closeLightbox(closeBtn);
    }
  });

  /* -------------------------------------------
     2. TOGGLE BUTTONS -> Open Lightboxes
     ------------------------------------------- */

  function initToggles() {
    var shippingToggle = document.getElementById('noble-toggle-shipping');
    var noteToggle = document.getElementById('noble-toggle-note');

    if (shippingToggle && !shippingToggle._nobleInit) {
      shippingToggle._nobleInit = true;
      shippingToggle.addEventListener('click', function() {
        openLightbox('noble-shipping-lightbox');
      });
    }

    if (noteToggle && !noteToggle._nobleInit) {
      noteToggle._nobleInit = true;
      noteToggle.addEventListener('click', function() {
        openLightbox('noble-note-lightbox');
      });
    }
  }

  /* -------------------------------------------
     3. ESTIMATE SHIPPING
     ------------------------------------------- */

  function initEstimateShipping() {
    var countrySelect = document.getElementById('noble-shipping-country');
    var provinceSelect = document.getElementById('noble-shipping-province');
    var estimateBtn = document.getElementById('noble-estimate-btn');
    var resultsDiv = document.getElementById('noble-shipping-results');

    if (!countrySelect || countrySelect._nobleInit) return;
    countrySelect._nobleInit = true;

    /* Use Shopify's built-in CountryProvinceSelector — same approach as Glozin theme */
    if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector('noble-shipping-country', 'noble-shipping-province', { hideElement: 'noble-shipping-province-container' });
    }

    /* Update shipping progress bar when country changes */
    countrySelect.addEventListener('change', function() {
      var countryName = countrySelect.value;
      if (!countryName) return;
      var isUS = (countryName === 'United States');
      var bar = document.querySelector('.noble-shipping-bar');
      if (!bar) return;
      var usThreshold = parseInt(bar.getAttribute('data-us-threshold')) || 3500;
      var intlThreshold = parseInt(bar.getAttribute('data-intl-threshold')) || 50000;
      var activeThreshold = isUS ? usThreshold : intlThreshold;
      var label = isUS ? 'US' : 'International';

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var total = cart.total_price;
          var remaining = activeThreshold - total;
          var pct = Math.min(100, Math.round((total / activeThreshold) * 100));
          var achieved = total >= activeThreshold;
          var progress = bar.querySelector('.noble-shipping-bar__progress');
          if (progress) progress.style.width = pct + '%';
          var msgEl = bar.querySelector('.noble-shipping-bar__message');
          if (achieved) {
            bar.classList.add('noble-shipping-bar--achieved');
            if (msgEl) {
              msgEl.className = 'noble-shipping-bar__message noble-shipping-bar__message--achieved';
              msgEl.innerHTML = '<span>Congratulations! You\'ve got <strong>free ' + label.toLowerCase() + ' shipping!</strong></span>';
            }
          } else {
            bar.classList.remove('noble-shipping-bar--achieved');
            var moneyStr = (remaining / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            if (msgEl) {
              msgEl.className = 'noble-shipping-bar__message';
              msgEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="6" width="15" height="13" rx="2"/><path d="M16 10h4l3 5v4h-7V10z"/><circle cx="5.5" cy="21.5" r="2.5"/><circle cx="18.5" cy="21.5" r="2.5"/></svg><span>Spend <strong>' + moneyStr + '</strong> more for <strong>Free ' + label + ' Shipping!</strong></span>';
            }
          }
        });
    });

    if (estimateBtn) {
      estimateBtn.addEventListener('click', function() {
        var countryName = countrySelect.value;
        var province = provinceSelect.value;
        var zip = document.getElementById('noble-shipping-zip').value;

        if (!countryName) {
          resultsDiv.innerHTML = '<div class="noble-shipping-result-error">Please select a country.</div>';
          resultsDiv.style.display = 'block';
          return;
        }

        resultsDiv.innerHTML = '<div class="noble-shipping-result-loading">Calculating shipping rates<span class="nc-dots"></span></div>';
        resultsDiv.style.display = 'block';
        estimateBtn.disabled = true;
        estimateBtn.textContent = 'Calculating...';

        var url = '/cart/shipping_rates.json?shipping_address%5Bcountry%5D=' + encodeURIComponent(countryName);
        if (province) url += '&shipping_address%5Bprovince%5D=' + encodeURIComponent(province);
        if (zip) url += '&shipping_address%5Bzip%5D=' + encodeURIComponent(zip);

        function fetchRates(attempt) {
          fetch(url)
            .then(function(r) { return r.text(); })
            .then(function(text) {
              var data = JSON.parse(text);
              if (data && data.shipping_rates) {
                if (data.shipping_rates.length > 0) {
                  var html = '<div class="nc-rate-header">Shipping rates for ' + (zip ? zip + ', ' : '') + countryName + (province ? ' ' + province : '') + '</div>';
                  data.shipping_rates.forEach(function(rate) {
                    var priceDisplay = parseFloat(rate.price) === 0 ? '<span class="nc-rate-free">FREE</span>' : '$' + rate.price;
                    var daysText = '';
                    if (rate.delivery_days && rate.delivery_days.length > 0) {
                      var d1 = rate.delivery_days[0];
                      var d2 = rate.delivery_days[rate.delivery_days.length - 1];
                      daysText = d1 === d2 ? ' (' + d1 + ' days)' : ' (' + d1 + ' - ' + d2 + ' days)';
                    }
                    html += '<div class="noble-shipping-result-item">';
                    html += '<span class="noble-shipping-result-item__name">' + rate.name + daysText + '</span>';
                    html += '<span class="noble-shipping-result-item__price">' + priceDisplay + '</span>';
                    html += '</div>';
                  });
                  resultsDiv.innerHTML = html;
                } else {
                  resultsDiv.innerHTML = '<div class="noble-shipping-result-error">No shipping rates available for this address.</div>';
                }
              } else {
                /* Error or 422 — show error messages or retry */
                var errors = [];
                Object.keys(data).forEach(function(key) {
                  if (Array.isArray(data[key])) errors.push(data[key][0]);
                });
                if (errors.length > 0) {
                  resultsDiv.innerHTML = '<div class="noble-shipping-result-error">' + errors.join('<br>') + '</div>';
                } else if (attempt < 5) {
                  setTimeout(function() { fetchRates(attempt + 1); }, 2000);
                  return;
                } else {
                  resultsDiv.innerHTML = '<div class="noble-shipping-result-error">Unable to calculate shipping rates. Please try again.</div>';
                }
              }
              estimateBtn.disabled = false;
              estimateBtn.textContent = 'Estimate';
            })
            .catch(function(err) {
              resultsDiv.innerHTML = '<div class="noble-shipping-result-error">Unable to estimate shipping. Please try again.</div>';
              estimateBtn.disabled = false;
              estimateBtn.textContent = 'Estimate';
            });
        }
        fetchRates(0);
      });
    }
  }

  /* -------------------------------------------
     4. URGENCY TIMER (2 minutes)
     ------------------------------------------- */

  var timerStarted = false;

  function initUrgencyTimer() {
    if (timerStarted) return;
    var timerEl = document.getElementById('noble-urgency-timer');
    var urgencyContainer = document.querySelector('.noble-urgency');
    if (!timerEl || !urgencyContainer) return;

    timerStarted = true;
    var totalSeconds = 2 * 60;

    function updateTimer() {
      if (totalSeconds <= 0) {
        timerEl.textContent = '00:00';
        urgencyContainer.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><span>You\'re out of time! Checkout now to avoid losing your order!</span>';
        return;
      }
      var mins = Math.floor(totalSeconds / 60);
      var secs = totalSeconds % 60;
      timerEl.textContent = (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
      totalSeconds--;
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  /* -------------------------------------------
     5. TERMS & CONDITIONS GATE
     ------------------------------------------- */

  function initTermsGate() {
    var checkbox = document.getElementById('noble-terms-checkbox');
    var checkoutBtn = document.getElementById('CartDrawer-Checkout');

    if (!checkbox || !checkoutBtn || checkbox._nobleInit) return;
    checkbox._nobleInit = true;

    function updateCheckoutState() {
      if (!checkbox.checked) {
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.pointerEvents = 'none';
      } else {
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.pointerEvents = 'auto';
      }
    }

    updateCheckoutState();
    checkbox.addEventListener('change', updateCheckoutState);
  }

  /* -------------------------------------------
     6. ORDER NOTE SAVE BUTTON
     ------------------------------------------- */

  function initOrderNoteSave() {
    var saveBtn = document.getElementById('noble-note-save-btn');
    if (!saveBtn || saveBtn._nobleInit) return;
    saveBtn._nobleInit = true;

    saveBtn.addEventListener('click', function() {
      var textarea = document.getElementById('CartDrawer-Note');
      if (!textarea) return;

      saveBtn.textContent = 'Saving...';
      saveBtn.disabled = true;

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: textarea.value })
      })
      .then(function() {
        saveBtn.textContent = 'Saved!';
        setTimeout(function() {
          saveBtn.textContent = 'Save Note';
          saveBtn.disabled = false;
          var lightbox = document.getElementById('noble-note-lightbox');
          if (lightbox) lightbox.style.display = 'none';
        }, 1000);
      })
      .catch(function() {
        saveBtn.textContent = 'Error - Try Again';
        saveBtn.disabled = false;
      });
    });
  }

  /* -------------------------------------------
     7. EDIT OPTION MODAL
     ------------------------------------------- */

  var editModalInitialized = false;

  function initEditOptionModal() {
    if (editModalInitialized) return;
    editModalInitialized = true;

    var overlay = document.getElementById('noble-edit-modal-overlay');
    var modalBody = document.getElementById('noble-edit-modal-body');
    if (!overlay) return;

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.noble-edit-option-btn');
      if (!btn) return;

      var productHandle = btn.dataset.productHandle;
      var currentVariantId = parseInt(btn.dataset.variantId);
      var lineIndex = parseInt(btn.dataset.lineIndex);
      var currentQty = parseInt(btn.dataset.itemQuantity);

      overlay.style.display = 'flex';
      modalBody.innerHTML = '<div class="noble-edit-modal__loading">Loading product options...</div>';

      fetch('/products/' + productHandle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          renderEditModal(product, currentVariantId, lineIndex, currentQty);
        })
        .catch(function(err) {
          console.error('Edit modal fetch error:', err);
          modalBody.innerHTML = '<div class="noble-edit-modal__loading">Failed to load product options.</div>';
        });
    });

    function renderEditModal(product, currentVariantId, lineIndex, currentQty) {
      var currentVariant = product.variants.find(function(v) { return v.id === currentVariantId; });
      var selectedOptions = [];

      if (currentVariant) {
        if (currentVariant.option1) selectedOptions.push(currentVariant.option1);
        if (currentVariant.option2) selectedOptions.push(currentVariant.option2);
        if (currentVariant.option3) selectedOptions.push(currentVariant.option3);
      }

      var html = '';

      // Product info
      var imgSrc = product.featured_image ? product.featured_image.replace(/\.([^.]+)$/, '_300x.$1') : '';
      html += '<div class="noble-edit-modal__product">';
      if (imgSrc) {
        html += '<img class="noble-edit-modal__product-image" src="' + imgSrc + '" alt="' + product.title + '">';
      }
      html += '<div class="noble-edit-modal__product-info">';
      html += '<p class="noble-edit-modal__product-title">' + product.title + '</p>';
      html += '<p class="noble-edit-modal__product-price" id="noble-edit-price">' + formatMoney(currentVariant ? currentVariant.price : product.price) + '</p>';
      html += '</div></div>';

      // Options - product.options from .js can be array of strings OR array of objects
      // Handle both formats
      var optionNames = [];
      if (product.options && product.options.length > 0) {
        product.options.forEach(function(opt) {
          if (typeof opt === 'string') {
            optionNames.push(opt);
          } else if (opt && opt.name) {
            optionNames.push(opt.name);
          } else {
            optionNames.push('Option');
          }
        });
      }

      optionNames.forEach(function(optName, optIdx) {
        html += '<div class="noble-edit-modal__option-group">';
        html += '<span class="noble-edit-modal__option-label">' + optName + '</span>';
        html += '<div class="noble-edit-modal__option-values" data-option-index="' + optIdx + '">';

        var values = [];
        product.variants.forEach(function(v) {
          var val = v['option' + (optIdx + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });

        values.forEach(function(val) {
          var isActive = selectedOptions[optIdx] === val;
          html += '<button type="button" class="noble-edit-modal__option-value' + (isActive ? ' active' : '') + '" data-option-index="' + optIdx + '" data-value="' + val + '">' + val + '</button>';
        });

        html += '</div></div>';
      });

      // Quantity
      html += '<div class="noble-edit-modal__quantity">';
      html += '<span class="noble-edit-modal__quantity-label">Quantity</span>';
      html += '<div class="noble-edit-modal__quantity-controls">';
      html += '<button type="button" class="noble-edit-modal__qty-btn" data-action="minus">\u2212</button>';
      html += '<input type="number" class="noble-edit-modal__qty-input" id="noble-edit-qty" value="' + currentQty + '" min="1">';
      html += '<button type="button" class="noble-edit-modal__qty-btn" data-action="plus">+</button>';
      html += '</div></div>';

      html += '<button type="button" class="noble-edit-modal__save-btn" id="noble-edit-save">Save Changes</button>';

      modalBody.innerHTML = html;

      var state = {
        options: selectedOptions.slice(),
        quantity: currentQty,
        product: product,
        originalVariantId: currentVariantId,
        lineIndex: lineIndex
      };

      modalBody.querySelectorAll('.noble-edit-modal__option-value').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var idx = parseInt(this.dataset.optionIndex);
          state.options[idx] = this.dataset.value;

          this.closest('.noble-edit-modal__option-values').querySelectorAll('.noble-edit-modal__option-value').forEach(function(b) {
            b.classList.remove('active');
          });
          this.classList.add('active');

          var matched = findVariant(product, state.options);
          if (matched) {
            document.getElementById('noble-edit-price').textContent = formatMoney(matched.price);
          }
          updateAvailability(product, state.options, modalBody);
        });
      });

      modalBody.querySelector('[data-action="minus"]').addEventListener('click', function() {
        var input = document.getElementById('noble-edit-qty');
        var val = parseInt(input.value);
        if (val > 1) { input.value = val - 1; state.quantity = val - 1; }
      });

      modalBody.querySelector('[data-action="plus"]').addEventListener('click', function() {
        var input = document.getElementById('noble-edit-qty');
        var val = parseInt(input.value);
        input.value = val + 1;
        state.quantity = val + 1;
      });

      document.getElementById('noble-edit-qty').addEventListener('change', function() {
        var val = parseInt(this.value);
        if (val < 1) val = 1;
        this.value = val;
        state.quantity = val;
      });

      document.getElementById('noble-edit-save').addEventListener('click', function() {
        var newVariant = findVariant(product, state.options);
        if (!newVariant) {
          alert('This variant combination is unavailable.');
          return;
        }

        var saveBtn = this;
        saveBtn.textContent = 'Saving...';
        saveBtn.disabled = true;

        if (newVariant.id === currentVariantId && state.quantity === currentQty) {
          overlay.style.display = 'none';
          return;
        }

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: state.lineIndex, quantity: 0 })
        })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: newVariant.id, quantity: state.quantity })
          });
        })
        .then(function() {
          overlay.style.display = 'none';
          location.reload();
        })
        .catch(function() {
          saveBtn.textContent = 'Error - Try Again';
          saveBtn.disabled = false;
        });
      });
    }

    function findVariant(product, options) {
      return product.variants.find(function(v) {
        var match = true;
        options.forEach(function(opt, idx) {
          if (v['option' + (idx + 1)] !== opt) match = false;
        });
        return match;
      });
    }

    function updateAvailability(product, currentOptions, container) {
      var optionNames = [];
      if (product.options) {
        product.options.forEach(function(opt) {
          optionNames.push(typeof opt === 'string' ? opt : (opt.name || 'Option'));
        });
      }

      optionNames.forEach(function(name, optIdx) {
        var group = container.querySelector('[data-option-index="' + optIdx + '"]');
        if (!group) return;

        group.querySelectorAll('.noble-edit-modal__option-value').forEach(function(btn) {
          var testOptions = currentOptions.slice();
          testOptions[optIdx] = btn.dataset.value;
          var exists = product.variants.some(function(v) {
            var match = true;
            testOptions.forEach(function(opt, i) {
              if (v['option' + (i + 1)] !== opt) match = false;
            });
            return match && v.available;
          });
          btn.classList.toggle('unavailable', !exists);
        });
      });
    }

    function formatMoney(cents) {
      if (typeof cents === 'string') cents = parseInt(cents);
      var amount = (cents / 100).toFixed(2);
      return '$' + amount;
    }
  }

  /* -------------------------------------------
     8. INIT
     ------------------------------------------- */

  function init() {
    initToggles();
    initEstimateShipping();
    initUrgencyTimer();
    initTermsGate();
    initOrderNoteSave();
    initEditOptionModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
